import Selector from './Selector';

/**
 * Helper to make it less verbose to select values from a list of options
 */
const ListSelector = ({ values, selected, onChange, disabled, className = '', label = '' }) => (
  <Selector
    options={values.map((v) => ({
      id: v,
      key: v,
      display: v,
    }))}
    selected={selected ? `${selected}` : ''}
    onChange={({ target: { value } }) => onChange(value)}
    disabled={disabled}
    className={className}
    label={label}
  />
);

export default ListSelector;
